import { HomeTransferContent } from '@interfaces/homeContent.interface';
import { Mockup } from '@interfaces/mockup.interface';


export const HOME_TRANSFER_CONTENT_RESPONSE: Mockup = {
    success: [{
        response: {
            data: {
                titulo: 'Vas a comenzar tu traspaso a AFP PlanVital',
                imagen_fondo: '433bed0a-244d-498a-bf80-75b3265d56b1',
                alt_image: 'Fondo AFP',
                subtitulo: 'A continuación podrás seleccionar el traspaso que más se adapte a tus necesidades.',
                metodos: [
                    {
                        home_traspaso_opciones_id: {
                            icono: '917e5041-a157-494d-ab0f-6fb69a4b65f6',
                            alt_image: 'Quiero que me llamen',
                            titulo: 'Quiero que me llamen',
                            descripcion: 'Ingresa aquí para poder contactar a un ejecutivo y realizar el traspaso.',
                            url: 'contactar'
                        }
                    },
                    {
                        home_traspaso_opciones_id: {
                            icono: '0c806bda-823e-436b-8447-caaa6234b5b0',
                            alt_image: 'Traspaso Web',
                            titulo: 'Traspaso Web',
                            descripcion: 'Ingresa aquí para realizar el proceso de traspaso sin asistencia y de manera online.',
                            url: 'ingresar'
                        }
                    },
                    {
                        home_traspaso_opciones_id: {
                            icono: 'b59027f5-4fcc-4644-9e00-5b97400a9f77',
                            alt_image: 'Traspaso asistido',
                            titulo: 'Traspaso asistido',
                            descripcion: 'Ingresa aquí si ya estás hablando con un ejecutivo.',
                            url: 'continuar'
                        }
                    },
                    {
                        home_traspaso_opciones_id: {
                            icono: '5110e23f-cee2-438d-8e31-1bd7e76cd723',
                            alt_image: 'Traspaso pensión de sobrevivencia',
                            titulo: 'Traspaso pensión sobrevivencia',
                            descripcion: 'Ingresa aquí para solicitar tu traspaso de pensión de sobrevivencia.',
                            url: 'afiliado/asesoria/transferencia-pension-sobrevivencia'
                        }
                    }
                ]
            }
}
    }],
    failures: []
};

export const HOME_TRANSFER_CONTENT: HomeTransferContent = {
    title: 'Vas a comenzar tu traspaso a AFP PlanVital',
    backImg: 'https://cms-qa.planvital.cl/assets/433bed0a-244d-498a-bf80-75b3265d56b1',
    altImage: 'Fondo AFP',
    subtitle: 'A continuación podrás seleccionar el traspaso que más se adapte a tus necesidades.',
    sections: [
        {
            iconUrl: 'https://cms-qa.planvital.cl/assets/917e5041-a157-494d-ab0f-6fb69a4b65f6',
            alt: 'Quiero que me llamen',
            imgTitle: 'Quiero que me llamen',
            title: 'Quiero que me llamen',
            description: 'Ingresa aquí para poder contactar a un ejecutivo y realizar el traspaso.',
            redirectTo: 'contactar'
        },
        {
            iconUrl: 'https://cms-qa.planvital.cl/assets/0c806bda-823e-436b-8447-caaa6234b5b0',
            alt: 'Traspaso Web',
            imgTitle: 'Traspaso Web',
            title: 'Traspaso Web',
            description: 'Ingresa aquí para realizar el proceso de traspaso sin asistencia y de manera online.',
            redirectTo: 'ingresar'
        },
        {
            iconUrl: 'https://cms-qa.planvital.cl/assets/b59027f5-4fcc-4644-9e00-5b97400a9f77',
            alt: 'Traspaso asistido',
            imgTitle: 'Traspaso asistido',
            title: 'Traspaso asistido',
            description: 'Ingresa aquí si ya estás hablando con un ejecutivo.',
            redirectTo: 'continuar'
        },
        {
            iconUrl: 'https://cms-qa.planvital.cl/assets/5110e23f-cee2-438d-8e31-1bd7e76cd723',
            alt: 'Traspaso pensión de sobrevivencia',
            imgTitle: 'Traspaso pensión de sobrevivencia',
            title: 'Traspaso pensión sobrevivencia',
            description: 'Ingresa aquí para solicitar tu traspaso de pensión de sobrevivencia.',
            redirectTo: 'afiliado/asesoria/transferencia-pension-sobrevivencia'
        }
    ]
};
